const calculateCashOnHandFlow = (totalIncome, totalCashPaid, startingCash) => {
  let result = { beginning: [], ending: [] };

  totalIncome =
    totalIncome && totalIncome.length
      ? totalIncome.slice(0, 12)
      : Array(12).fill(0);
  totalCashPaid =
    totalCashPaid && totalCashPaid.length
      ? totalCashPaid.slice(0, 12)
      : Array(12).fill(0);

  let initialBeginning = startingCash || 0;
  result.beginning.push(initialBeginning);

  for (let i = 0; i < totalIncome.length; i++) {
    let endingValue = result.beginning[i] + totalIncome[i] - totalCashPaid[i];
    result.ending.push(endingValue);

    if (i + 1 < totalIncome.length) {
      result.beginning.push(endingValue);
    }
  }

  result.beginning.push(result.ending[result.ending.length - 1]);

  return result;
};

export default calculateCashOnHandFlow;
